import React from "react"
import ReportDivisions from "./fields/ReportDivisions"
import ReportFacilities from "./fields/ReportFacilities"
import ReportAccountingBatches from "./fields/ReportAccountingBatches"
import ReportDateRange from "./fields/ReportDateRange"
import ReportMonthEnd from "./fields/ReportMonthEnd"
import ReportVendors from "./fields/ReportVendors"
import ReportBillableAccounts from "./fields/ReportBillableAccounts"
import ReportSupplyAccounts from "./fields/ReportSupplyAccounts"
import ReportUtilityServices from "./fields/ReportUtilityServices"

export default function Accrual() {
    return (
        <div>
            <ReportDateRange required={false} />
            <ReportMonthEnd />
            <ReportUtilityServices mode='multiple' required={false} />
            {/* <ReportAccountingBatches /> */}
            <ReportDivisions />
            <ReportFacilities />
            <ReportVendors />
            <ReportBillableAccounts />
            <ReportSupplyAccounts />
        </div>
    )
}
